module.exports = __webpack_public_path__ + "static/media/2.1.f1c9027b.png";